export default __webpack_public_path__ + "static/media/BG-Yellow-0001.fae9014d.png";